module.exports = __webpack_public_path__ + "img/color_block_9.97155a5e.svg";